import {SlideshowSlideMobile} from './Slideshow.SlideMobile'
import {SlideshowSlideDesktop} from './Slideshow.SlideDesktop'

interface SlideshowSlideProps {
  index: number
}

export const SlideshowSlide = ({index}: SlideshowSlideProps) => {
  return (
    <div className={'size-full'}>
      <SlideshowSlideMobile index={index} />
      <SlideshowSlideDesktop index={index} />
    </div>
  )
}
